import React, { useEffect, useState, createElement } from 'react';
import { Check, ChevronDown, ShieldCheck, Lock, Download, Clock, CheckCircle, Palette, BookOpen, Users, Star, ArrowRight, Sparkles, GraduationCap, Heart, ChevronLeft, ChevronRight } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
function App() {
  const [activeAccordion, setActiveAccordion] = useState<number | null>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const previewImages = ['https://cdn.magicpatterns.com/uploads/17uU1TWBiYSKg4rqqXkefW/Captura_de_pantalla_2026-02-05_a_las_1.41.05_p._m..png', 'https://cdn.magicpatterns.com/uploads/v9fby5GTTwo2VziirW7WaV/Captura_de_pantalla_2026-02-05_a_las_1.41.14_p._m..png', 'https://cdn.magicpatterns.com/uploads/jLTtqEbfX18XWFtvJeP8Sq/Captura_de_pantalla_2026-02-05_a_las_1.41.26_p._m..png', 'https://cdn.magicpatterns.com/uploads/4QmwBnByzaeQbhHnrSGtXG/Captura_de_pantalla_2026-02-05_a_las_1.41.42_p._m..png', 'https://cdn.magicpatterns.com/uploads/ra3SBuPWwCSkWEmk9kj84t/Captura_de_pantalla_2026-02-05_a_las_1.42.13_p._m..png', 'https://cdn.magicpatterns.com/uploads/9dEDE1zVcnot21Bf9qTBEy/Captura_de_pantalla_2026-02-05_a_las_1.42.35_p._m..png', 'https://cdn.magicpatterns.com/uploads/r6rw4HrveQ2Kfh2cfBsTbs/Captura_de_pantalla_2026-02-05_a_las_1.52.03_p._m..png', 'https://cdn.magicpatterns.com/uploads/42U4cy7yTLU2Uy7s2Qcbnc/Captura_de_pantalla_2026-02-05_a_las_1.52.18_p._m..png'];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % previewImages.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + previewImages.length) % previewImages.length);
  };
  const toggleAccordion = (index: number) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleCheckout = () => {
    window.location.href = 'https://checkout12.edulabs.online/cart/52932970873197:1';
  };
  // Meta Pixel tracking
  useEffect(() => {
    if ((window as any).fbq) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = () => {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('init', '1960776658179709');
        (window as any).fbq('track', 'PageView');
      }
    };
    (window as any).fbq = function () {
      ;
      (window as any).fbq.callMethod ? (window as any).fbq.callMethod.apply((window as any).fbq, arguments) : (window as any).fbq.queue.push(arguments);
    };
    (window as any).fbq.push = (window as any).fbq;
    (window as any).fbq.loaded = true;
    (window as any).fbq.version = '2.0';
    (window as any).fbq.queue = [];
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-0">
      {/* Meta Pixel noscript */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1960776658179709&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <CountdownTimer data-id="element-3" />

      {/* Hero Section */}
      <section className="bg-white pt-6 pb-8 px-4" data-id="element-4">
        <div className="max-w-4xl mx-auto text-center" data-id="element-5">
          {/* Badge */}
          <div className="flex justify-center mb-4" data-id="element-6">
            <span className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 px-5 py-2 rounded-full text-sm font-bold border border-blue-200" data-id="element-7">
              <Palette className="w-4 h-4" data-id="element-8" />
              PARA DOCENTES DE ARTE
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-xl md:text-3xl font-black text-slate-900 mb-4 leading-tight" data-id="element-9">
            Organizá todo tu año de Arte y{' '}
            <span className="text-blue-600" data-id="element-10">
              ahorrá hasta 12 meses de planificación
            </span>{' '}
            con el MegaPack Arte Lista
          </h1>

          {/* Product Image */}
          <div className="relative max-w-[240px] mx-auto mb-4" data-id="element-11">
            <img src="https://cdn.magicpatterns.com/uploads/mURUu4Lxepafmsoxr28nh3/PROYECTOS_Anuales_(1080_x_900_px)_(2).png" alt="MegaPack Arte Lista" className="w-full drop-shadow-xl" data-id="element-12" />
          </div>

          {/* Brand Name */}
          <div className="flex items-center justify-center gap-2 text-blue-600 font-bold text-base mb-2" data-id="element-13">
            <Palette className="w-4 h-4" data-id="element-14" />
            MEGAPACK ARTE LISTA™
          </div>

          {/* Subtitle */}
          <p className="text-base text-slate-600 mb-1 max-w-2xl mx-auto" data-id="element-15">
            Sistema completo de actividades, proyectos y experiencias artísticas
            listas para usar.
          </p>
          <p className="text-sm font-bold text-slate-900 mb-5" data-id="element-16">
            Todo tu año de Arte resuelto (todos los niveles)
          </p>

          {/* CTA Button */}
          <button onClick={scrollToPurchase} className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold text-base px-8 py-3.5 rounded-lg shadow-lg hover:shadow-xl transition-all mb-4" data-id="element-17">
            👉 SÍ, QUIERO ACCESO INMEDIATO
            <ArrowRight className="w-5 h-5" data-id="element-18" />
          </button>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5 text-xs text-slate-500" data-id="element-19">
            <span className="flex items-center gap-1" data-id="element-20">
              <Lock className="w-3.5 h-3.5" data-id="element-21" />
              Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-22">
              <Download className="w-3.5 h-3.5" data-id="element-23" />
              Descarga inmediata
            </span>
            <span className="flex items-center gap-1" data-id="element-24">
              <Clock className="w-3.5 h-3.5" data-id="element-25" />
              Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-26">
              <Check className="w-3.5 h-3.5" data-id="element-27" />
              Acceso de por vida
            </span>
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-slate-50" data-id="element-28">
        <div className="max-w-3xl mx-auto" data-id="element-29">
          <h2 className="text-2xl md:text-4xl font-bold text-center text-slate-900 mb-8" data-id="element-30">
            Si enseñás Arte, esto te va a{' '}
            <span className="text-blue-600" data-id="element-31">sonar familiar...</span>
          </h2>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200" data-id="element-32">
            <p className="text-lg text-slate-700 leading-relaxed mb-6" data-id="element-33">
              Llegás del trabajo <strong data-id="element-34">cansado</strong> y todavía tenés que
              pensar: qué actividad hacer, con qué materiales, cómo adaptarla al
              grupo, cómo justificarla, cómo evaluarla…
            </p>
            <p className="text-lg text-slate-700 leading-relaxed mb-6" data-id="element-35">
              Buscás ideas, guardás links, armás carpetas que después no volvés
              a abrir. Planificar arte consume tiempo, energía y creatividad.
            </p>
            <div className="space-y-3 text-lg" data-id="element-36">
              <p className="flex items-start gap-2" data-id="element-37">
                <span className="text-blue-600 font-bold" data-id="element-38">👉</span>
                <span data-id="element-39">No es falta de vocación.</span>
              </p>
              <p className="flex items-start gap-2" data-id="element-40">
                <span className="text-blue-600 font-bold" data-id="element-41">👉</span>
                <span data-id="element-42">
                  Es falta de un{' '}
                  <strong data-id="element-43">sistema que te sostenga todo el año.</strong>
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-16 px-4 bg-white" data-id="element-44">
        <div className="max-w-4xl mx-auto text-center" data-id="element-45">
          <p className="text-blue-600 font-bold text-lg mb-4" data-id="element-46">La Solución</p>
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6" data-id="element-47">
            🎨 MEGAPACK ARTE LISTA™
          </h2>
          <p className="text-lg text-slate-600 mb-10 max-w-2xl mx-auto" data-id="element-48">
            Un sistema completo de actividades, proyectos, procesos y evaluación
            artística, probado en el aula y listo para aplicar, sin improvisar.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-49">
            {['Listo', 'Probado', 'Organizado', 'Usable'].map(item => <span key={item} className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-full font-semibold" data-id="element-50">
                <Check className="w-4 h-4" data-id="element-51" />
                {item}
              </span>)}
          </div>
        </div>
      </section>

      {/* What's Included Section */}
      <section className="py-16 px-4 bg-slate-50" data-id="element-52">
        <div className="max-w-4xl mx-auto" data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-black text-center text-slate-900 mb-12" data-id="element-54">
            ¿Qué incluye el MegaPack Arte Lista?
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-55">
            <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200" data-id="element-56">
              <div className="flex items-start gap-4" data-id="element-57">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-58">
                  <BookOpen className="w-6 h-6 text-blue-600" data-id="element-59" />
                </div>
                <div data-id="element-60">
                  <h3 className="font-bold text-lg text-slate-900 mb-2" data-id="element-61">
                    6 Tomos completos en PDF
                  </h3>
                  <p className="text-slate-600 text-sm" data-id="element-62">
                    <strong data-id="element-63">Tomos 1 a 5:</strong> actividades prácticas listas
                    para usar
                    <br data-id="element-64" />
                    <strong data-id="element-65">Tomo 6:</strong> procesos, evaluación y rol docente
                    en Arte
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200" data-id="element-66">
              <div className="flex items-start gap-4" data-id="element-67">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-68">
                  <Sparkles className="w-6 h-6 text-blue-600" data-id="element-69" />
                </div>
                <div data-id="element-70">
                  <h3 className="font-bold text-lg text-slate-900 mb-2" data-id="element-71">
                    +150 actividades artísticas
                  </h3>
                  <p className="text-slate-600 text-sm" data-id="element-72">
                    Adaptables por nivel educativo
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200" data-id="element-73">
              <div className="flex items-start gap-4" data-id="element-74">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-75">
                  <CheckCircle className="w-6 h-6 text-blue-600" data-id="element-76" />
                </div>
                <div data-id="element-77">
                  <h3 className="font-bold text-lg text-slate-900 mb-2" data-id="element-78">
                    Proyectos anuales listos
                  </h3>
                  <p className="text-slate-600 text-sm" data-id="element-79">
                    Guías, plantillas y rúbricas incluidas
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200" data-id="element-80">
              <div className="flex items-start gap-4" data-id="element-81">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-82">
                  <Download className="w-6 h-6 text-blue-600" data-id="element-83" />
                </div>
                <div data-id="element-84">
                  <h3 className="font-bold text-lg text-slate-900 mb-2" data-id="element-85">
                    Material imprimible y editable
                  </h3>
                  <p className="text-slate-600 text-sm" data-id="element-86">
                    Todo organizado por bloques temáticos
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 border-2 border-yellow-200 rounded-xl p-6 text-center" data-id="element-87">
            <p className="text-lg font-bold text-slate-900" data-id="element-88">
              ⚠️ No es curso. No es video. Es{' '}
              <span className="text-blue-600" data-id="element-89">material real para enseñar.</span>
            </p>
          </div>
        </div>
      </section>

      {/* Preview Section */}
      <section className="py-16 px-4 bg-white" data-id="element-90">
        <div className="max-w-4xl mx-auto text-center" data-id="element-91">
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4" data-id="element-92">
            👀 MIRÁ POR DENTRO
          </h2>
          <p className="text-lg text-slate-600 mb-10" data-id="element-93">
            Páginas reales del material
          </p>

          {/* Carousel */}
          <div className="relative bg-slate-100 rounded-2xl p-4 md:p-8 mb-8" data-id="element-94">
            <div className="relative overflow-hidden" data-id="element-95">
              <div className="flex transition-transform duration-500 ease-out" style={{
              transform: `translateX(-${currentSlide * 100}%)`
            }} data-id="element-96">
                {previewImages.map((image, i) => <div key={i} className="w-full flex-shrink-0 px-2" data-id="element-97">
                    <img src={image} alt={`Página ${i + 1} del material`} className="w-full max-w-lg mx-auto rounded-lg shadow-lg" data-id="element-98" />
                  </div>)}
              </div>
            </div>

            {/* Navigation Arrows */}
            <button onClick={prevSlide} className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-slate-700 p-2 md:p-3 rounded-full shadow-lg transition-all" aria-label="Anterior" data-id="element-99">
              <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" data-id="element-100" />
            </button>
            <button onClick={nextSlide} className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-slate-700 p-2 md:p-3 rounded-full shadow-lg transition-all" aria-label="Siguiente" data-id="element-101">
              <ChevronRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-102" />
            </button>

            {/* Dots Indicator */}
            <div className="flex justify-center gap-2 mt-6" data-id="element-103">
              {previewImages.map((_, i) => <button key={i} onClick={() => setCurrentSlide(i)} className={`w-2.5 h-2.5 rounded-full transition-all ${currentSlide === i ? 'bg-blue-600 w-6' : 'bg-slate-300 hover:bg-slate-400'}`} aria-label={`Ir a página ${i + 1}`} data-id="element-104" />)}
            </div>
          </div>

          <p className="text-slate-600" data-id="element-105">
            Actividades paso a paso, consignas claras y propuestas aplicables
            desde el día 1.
          </p>
        </div>
      </section>

      {/* Results Section */}
      <section className="py-16 px-4 bg-slate-50" data-id="element-106">
        <div className="max-w-5xl mx-auto" data-id="element-107">
          <h2 className="text-3xl md:text-4xl font-black text-center text-slate-900 mb-12" data-id="element-108">
            Resultados que transforman
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-109">
            {/* For Students */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200" data-id="element-110">
              <div className="flex items-center gap-3 mb-6" data-id="element-111">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-112">
                  <Palette className="w-6 h-6 text-blue-600" data-id="element-113" />
                </div>
                <h3 className="text-xl font-bold text-slate-900" data-id="element-114">
                  Para tus Estudiantes
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-115">
                {['Se expresan sin miedo al error', 'Desarrollan creatividad y pensamiento crítico', 'Participan más en clase', 'Disfrutan el proceso, no solo el resultado'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-116">
                    <Check className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-117" />
                    <span className="text-slate-700" data-id="element-118">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* For Teachers */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200" data-id="element-119">
              <div className="flex items-center gap-3 mb-6" data-id="element-120">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-121">
                  <GraduationCap className="w-6 h-6 text-blue-600" data-id="element-122" />
                </div>
                <h3 className="text-xl font-bold text-slate-900" data-id="element-123">
                  Para Vos como Docente
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-124">
                {['Ahorrás horas de planificación', 'Tenés todo organizado', 'Enseñás con seguridad y claridad', 'Llegás al cierre del año sin estrés'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-125">
                    <Check className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-126" />
                    <span className="text-slate-700" data-id="element-127">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center mt-10" data-id="element-128">
            <button onClick={scrollToPurchase} className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg px-8 py-4 rounded-lg shadow-lg transition-all" data-id="element-129">
              👉 QUIERO LOGRAR ESTO
            </button>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 px-4 bg-white" data-id="element-130">
        <div className="max-w-4xl mx-auto" data-id="element-131">
          <div className="text-center mb-12" data-id="element-132">
            <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4" data-id="element-133">
              🎁 BONOS GRATIS HOY
            </h2>
            <p className="text-slate-500" data-id="element-134">(Sin costo adicional)</p>
          </div>

          <div className="space-y-6" data-id="element-135">
            {[{
            number: 1,
            title: 'Planificaciones Docentes Listas',
            description: 'Modelos claros y organizados para aplicar sin pensar ni rehacer.',
            value: '$15 USD',
            image: 'https://cdn.magicpatterns.com/uploads/4kDPgSTk1DuPSUE2ocDNGc/PROYECTOS_Anuales_(1080_x_900_px)_(3).png'
          }, {
            number: 2,
            title: 'Libros Digitales de Arte',
            description: 'Material visual sobre técnicas, artistas y movimientos artísticos.',
            value: '$15 USD',
            image: 'https://cdn.magicpatterns.com/uploads/bgXVuDJy5SqBb1ZJMsazsV/pasted-image.png'
          }, {
            number: 3,
            title: 'Proyectos Artísticos Anuales',
            description: 'Propuestas completas para trabajar durante todo el año escolar.',
            value: '$15 USD',
            image: 'https://cdn.magicpatterns.com/uploads/hX249oV1EykgjFV6fXXc5B/pasted-image.png'
          }].map(bonus => <div key={bonus.number} className="bg-gradient-to-r from-blue-50 to-white rounded-xl p-6 border-2 border-blue-100 flex flex-col md:flex-row md:items-center gap-6" data-id="element-136">
                <div className="w-48 h-48 flex-shrink-0 mx-auto md:mx-0" data-id="element-137">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain drop-shadow-xl" data-id="element-138" />
                </div>
                <div className="flex-grow text-center md:text-left" data-id="element-139">
                  <h3 className="font-bold text-lg text-slate-900 mb-1" data-id="element-140">
                    🎁 BONO #{bonus.number} – {bonus.title}
                  </h3>
                  <p className="text-slate-600" data-id="element-141">{bonus.description}</p>
                </div>
                <div className="text-center md:text-right flex-shrink-0" data-id="element-142">
                  <p className="text-slate-400 line-through text-sm" data-id="element-143">
                    Valor: {bonus.value}
                  </p>
                  <p className="text-blue-600 font-bold text-lg" data-id="element-144">GRATIS</p>
                </div>
              </div>)}
          </div>

          <div className="text-center mt-10" data-id="element-145">
            <p className="text-lg font-semibold text-slate-700" data-id="element-146">
              🎯 Estos bonos complementan el MegaPack y{' '}
              <span className="text-blue-600" data-id="element-147">multiplican su valor.</span>
            </p>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="purchase" className="py-8 md:py-16 px-3 md:px-4 bg-slate-900" data-id="element-148">
        <div className="max-w-md mx-auto" data-id="element-149">
          <div className="bg-white rounded-2xl overflow-hidden shadow-2xl" data-id="element-150">
            {/* Red Header */}
            <div className="bg-red-500 py-3 px-4 text-center" data-id="element-151">
              <p className="text-white font-bold text-xs md:text-base tracking-wide" data-id="element-152">
                🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
              </p>
            </div>

            {/* Content */}
            <div className="p-5 md:p-10" data-id="element-153">
              {/* Title */}
              <h2 className="text-xl md:text-3xl font-black text-slate-900 text-center mb-2" data-id="element-154">
                MEGAPACK ARTE LISTA
              </h2>

              {/* Subtitle */}
              <p className="text-blue-600 font-bold text-center text-base md:text-lg mb-5 md:mb-8" data-id="element-155">
                6 Tomos Base + 3 Bonos PRO
              </p>

              {/* Features List */}
              <div className="space-y-2.5 md:space-y-4 mb-5 md:mb-8" data-id="element-156">
                {['Pago único', 'Acceso de por vida', 'Descarga inmediata', 'Garantía 7 días', '3 Bonos incluidos'].map((feature, i) => <div key={i} className="flex items-center gap-2.5" data-id="element-157">
                    <Check className="w-4 h-4 md:w-5 md:h-5 text-blue-600 flex-shrink-0" data-id="element-158" />
                    <span className="text-slate-800 text-base md:text-lg" data-id="element-159">
                      {feature}
                    </span>
                  </div>)}
              </div>

              {/* Price */}
              <div className="text-center mb-5 md:mb-8" data-id="element-160">
                <p className="text-slate-400 line-through text-sm md:text-lg mb-1" data-id="element-161">
                  Precio regular $49.99 USD
                </p>
                <div className="flex items-baseline justify-center gap-2" data-id="element-162">
                  <span className="text-5xl md:text-7xl font-black text-slate-900" data-id="element-163">
                    $12.99
                  </span>
                  <span className="text-xl md:text-2xl font-bold text-slate-600" data-id="element-164">
                    USD
                  </span>
                </div>
                <p className="text-slate-500 text-xs md:text-sm mt-1" data-id="element-165">
                  Pago único · Pagarás en tu moneda local
                </p>
              </div>

              {/* CTA Button */}
              <button onClick={handleCheckout} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold text-base md:text-lg py-4 md:py-5 rounded-xl shadow-lg transition-all flex items-center justify-center gap-2" data-id="element-166">
                <span data-id="element-167">👉</span>
                <span data-id="element-168">SÍ, QUIERO EL MEGAPACK</span>
                <ArrowRight className="w-4 h-4 md:w-5 md:h-5" data-id="element-169" />
              </button>
            </div>
          </div>

          {/* Guarantee below card */}
          <div className="mt-5 md:mt-8 text-center" data-id="element-170">
            <div className="inline-flex items-center gap-2 text-white/80 text-xs md:text-sm" data-id="element-171">
              <ShieldCheck className="w-4 h-4 md:w-5 md:h-5" data-id="element-172" />
              <span data-id="element-173">Garantía de satisfacción de 7 días</span>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 px-4 bg-white" data-id="element-174">
        <div className="max-w-4xl mx-auto" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-black text-center text-slate-900 mb-12" data-id="element-176">
            🗣️ Testimonios de Docentes
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-177">
            {[{
            name: 'Laura M.',
            role: 'Docente de Arte (Argentina)',
            quote: 'Ahora tengo todo el año resuelto. Las clases fluyen y mis alumnos están más motivados.'
          }, {
            name: 'Carlos R.',
            role: 'Profesor de Secundaria (México)',
            quote: 'Las actividades son claras y reales. Dejé de improvisar.'
          }, {
            name: 'Ana P.',
            role: 'Docente de Primaria (Chile)',
            quote: 'El Tomo 6 me ayudó a evaluar arte sin frustrar a mis alumnos.'
          }].map((testimonial, i) => <div key={i} className="bg-slate-50 rounded-xl p-6 border border-slate-200" data-id="element-178">
                <div className="flex gap-1 mb-4" data-id="element-179">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-180" />)}
                </div>
                <p className="text-slate-700 italic mb-4" data-id="element-181">
                  "{testimonial.quote}"
                </p>
                <div data-id="element-182">
                  <p className="font-bold text-slate-900" data-id="element-183">{testimonial.name}</p>
                  <p className="text-sm text-slate-500" data-id="element-184">{testimonial.role}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-slate-50" data-id="element-185">
        <div className="max-w-3xl mx-auto" data-id="element-186">
          <h2 className="text-3xl md:text-4xl font-black text-center text-slate-900 mb-12" data-id="element-187">
            ❓ Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-188">
            {[{
            q: '¿En qué formato recibo el material?',
            a: 'En PDF descargable.'
          }, {
            q: '¿Puedo imprimir los cuadernillos?',
            a: 'Sí, todo el material es imprimible.'
          }, {
            q: '¿Para qué niveles sirve?',
            a: 'Inicial, Primaria y Secundaria (con adaptaciones sugeridas).'
          }, {
            q: '¿Necesito materiales especiales?',
            a: 'No. Se usan materiales accesibles y escolares.'
          }, {
            q: '¿Cuánto tarda en llegar?',
            a: 'Acceso inmediato luego del pago.'
          }].map((faq, i) => <div key={i} className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-id="element-189">
                <button onClick={() => toggleAccordion(i)} className="w-full flex items-center justify-between p-5 text-left hover:bg-slate-50 transition-colors" data-id="element-190">
                  <span className="font-bold text-slate-900" data-id="element-191">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform ${activeAccordion === i ? 'rotate-180' : ''}`} data-id="element-192" />
                </button>
                {activeAccordion === i && <div className="px-5 pb-5 text-slate-600 border-t border-slate-100 pt-4" data-id="element-193">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4 bg-blue-600" data-id="element-194">
        <div className="max-w-3xl mx-auto text-center" data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-196">
            ¿Listo para transformar tu año escolar?
          </h2>
          <p className="text-xl text-blue-100 mb-8" data-id="element-197">
            Unite a docentes que ya enseñan Arte con menos estrés y más sentido.
          </p>
          <button onClick={scrollToPurchase} className="inline-flex items-center gap-2 bg-white text-blue-600 hover:bg-blue-50 font-black text-xl px-10 py-5 rounded-xl shadow-lg transition-all" data-id="element-198">
            👉 QUIERO EMPEZAR AHORA
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-10 px-4 text-center" data-id="element-199">
        <div className="max-w-4xl mx-auto" data-id="element-200">
          <div className="flex items-center justify-center gap-2 text-white font-bold text-lg mb-4" data-id="element-201">
            <Palette className="w-5 h-5" data-id="element-202" />
            MEGAPACK ARTE LISTA™
          </div>
          <p className="mb-4 text-sm" data-id="element-203">
            © 2026 MegaPack Arte Lista™ Todos los derechos reservados
          </p>
          <div className="flex justify-center gap-4 text-sm" data-id="element-204">
            <a href="#" className="hover:text-white transition-colors" data-id="element-205">
              Términos
            </a>
            <span data-id="element-206">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-207">
              Privacidad
            </a>
            <span data-id="element-208">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-209">
              Soporte
            </a>
          </div>
        </div>
      </footer>
    </div>;
}
export { App };